import React from "react";
import mindimag from "../../Images/Psynexa website photos cover 3.jpg";
import "./Home.css";
import Sliderimg from "../../commanfile/Sliderimg";
import peapleimg from "../../Images/Psynexa website photos cover 1.jpg";
import Box from "../../commanfile/Box";
import ApointmentForm from "../../commanfile/ApointmentForm";
import Button from "../../commanfile/Button";
import ServiceImages from "../../commanfile/ServiceImages";
import Tretmentwork from "../../commanfile/Tretmentwork";
import imageone from "../../Images/personalizesupporyimage.jpg"
import imagetwo from "../../Images/onetoonrcounsiling.png"
import imagethree from "../../Images/peersupportimage.png"
import imagefour from "../../Images/individualplanimage.png"
import Iconehelthpage from "../../commanfile/Iconehelthpage";

const Home = () => {
  return (
    <>
      <div className="max-w-[1456px] mx-auto">
        <div className=" mx-auto mt-2 ">
          <Sliderimg />
        </div>
        <div className="mx-auto sm:px-6 px-2 md:px-14">
          <div className="mt-10">
            <div className="flex flex-wrap justify-around items-center">
              <div className="p-2 md:w-[50%] w-full  ">
                <span className="font-roboto text-[#469B8F] font-bold text-xl sm:text-2xl md:text-3xl">
                  About Psynexa
                </span>
                <p className="font-roboto uppercase md:leading-[40px] text-xl sm:text-[20px] md:text-[30px] mt-4">
                  There is no shame in seeking help for your mental health
                </p>
                <p className=" mb-5  sm:mb-10 font-roboto mt-2 md:text-xl sm:text-xl text-base text-justify   ">
                  Psynexa Mind Care Hospital is a revolutionary mental
                  healthcare hospital in India with integrating cutting-edge
                  clinical science with modern technological advancements. The
                  organisation aims to create a mental health ecosystem where
                  compassionate care meets expertise. Our innovative approach
                  ensures personalized & effective care for every individual and
                  their family.
                </p>
                <Button
                  className={
                    " bg-[#469B8F] hover:bg-[#3bae9f] font-roboto  text-white  text-xl rounded-full px-8 py-3 "
                  }
                  btnName={"Learn More"}
                  link={"/AboutHospital"}
                ></Button>
              </div>
              <div className=" md:w-[50%]  ">
                <img src={mindimag} className="md:h-[60%] sm:h-[40%]" />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3 mx-auto sm:px-6 px-2 md:px-14 h-[350px] sm:h-[280px] md:h-[150px] bg-[#fecace] flex flex-wrap md:flex-nowrap items-center justify-center md:p-5  md:gap-4 sm:p-2 text-center">
          <div>
            <div className="md:border-r-4 border-gray-500 mx-auto text-center w-[80%] ">
              <p className="text-center font-roboto text-[#385a64] md:text-2xl sm:text-xl text-xl pr-3 ">
                Nurturing Mental Well-being with Expert Care
              </p>
            </div>
          </div>
          <div className="sm:flex py-3 ">
            <div className="sm:p-4 md:p-8 p-2 mt-2 ">
              <span className="font-roboto text-[#385a64] font-semibold md:text-3xl sm:text-2xl text-xl">
                10k +
              </span>
              <p className="font-roboto text-[#385a64] text-xl md:text-2xl sm:text-xl">
                Happy client
              </p>
            </div>
            <div className="sm:p-4 md:p-8 p-2 mt-2">
              <span className="font-roboto font-semibold text-[#385a64] md:text-3xl sm:text-2xl text-xl">
                97%
              </span>
              <p className="font-roboto text-[#385a64] text-xl md:text-2xl sm:text-xl">
                Problem solved
              </p>
            </div>
            <div className="sm:p-4 md:p-8 mt-2">
              <span className="font-roboto text-[#385a64] font-semibold md:text-3xl sm:text-2xl text-xl">
                8 +
              </span>
              <p className="font-roboto text-xl md:text-2xl sm:text-xl text-[#385a64]">
                year Experience
              </p>
            </div>
          </div>
        </div>

        <div className=" container mx-auto px-4 mt-10 items-center">
          <div className=" items-center flex flex-col mt-5 sm:px-10  md:px-20 px-5  ">
            <p className="text-center font-roboto text-2xl leading-relaxed font-semibold mb-6 ">
              WHAT WE OFFER
            </p>
            <p className="font-roboto font-bold uppercase text-xl md:text-4xl leading-tight text-center min-w-full  md:w-[50%] mb-3 ">
              Awareness today, better mental health tomorrow
            </p>
          </div>
          <ServiceImages />
        </div>

        <div className="container mx-auto px-4 mt-20 items-center ">
          <div className="rounded-2xl md:flex  justify-center gap-2 items-center  bg-red-100">
            <div>
              <img src={peapleimg} className="rounded-2xl" />
            </div>
            <div className="items-center mx-auto px-3 sm:px-5 md:px-10">
              <p className="font-roboto font-bold md:text-3xl sm:text-2xl text-xl mt-2   ">
                If we don’t talk about mental health, how can we ever break the
                cycle of stigma?
              </p>
              <p className="font-roboto font-light md:text-xl sm:text-lg text-base px-1 md:px-7 sm:px-3 mt-8 text-justify">
                1 in 4 people are affected by a mental illness at some point in
                their lives. Still, people are afraid to share about their
                mental health because they worry that they will be judged or,
                something worse will happen, that they could lose their
                identity.
              </p>
              <p className="font-roboto font-light text-xl px-1 md:px-7 sm:px-3 mt-3   text-justify">
                Psynexa Mind Care Hospital is dedicated to creating a future
                where everyone can access, embrace, and take care of their
                mental health.
              </p>
              <div className="mx-3 my-4 sm:mx-5 sm:my-5 md:mx-10 md:my-10 pb-3 ">
                <Button
                  className={
                    "font-roboto mx-auto bg-[#469B8F] hover:bg-white hover:text-[#469B8F] text-white text-base sm:text-lg md:text:xl rounded-full px-8 py-2 shadow-cyan-900 shadow-2xl "
                  }
                  btnName={"Contact Us"}
                  link={"/Contactus"}
                ></Button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 md:pl-[40px] md:pr-[40px] ">
          <div className="text-center mx-auto justify-center items-center flex flex-col">
            <p className="font-roboto  flex  items-center uppercase justify-between font-semibold text-2xl  ">
             Don’t wait for health — schedule it today
            </p>
          </div>
          <Tretmentwork />
        </div>

        <div className="py-10 px-10">
           <div className="bg-[#e7f2f2] rounded-xl px-10 py-10">
         <Iconehelthpage/>
        </div>
        </div>

        <div className=" mt-5">
          <div className="mx-auto ">
            <p className="font-roboto  text-[#385a64] font-semibold text-center text-2xl pt-5 ">
              Why Choose Us ??
            </p>
            
          </div>
          <div className=" sm:flex md:flex gap-5 sm:gap-3 sm:px-2 justify-center py-5">
            <div className="border-lime-500 md:w-[280px] md:h-[300px] h-[200px] w-[340px] content-center sm:my-0  mx-auto md:mx-0  border-t-4  shadow-md rounded-lg text-center ">
              <Box
                images={imageone}
                title={"Personalised support"}
                content={
                  "We listen closely, understand deeply, and design care plans tailored to each person’s specific needs."
                }
              />
            </div>
            <div className=" border-red-500 md:w-[280px] md:h-[300px] h-[200px] w-[340px] content-center sm:my-0  mx-auto md:mx-0  border-t-4  shadow-md rounded-lg text-center ">
              <Box
              images={imagetwo}
                title={"One-on-One Counseling"}
                content={" Dedicated therapists to guide your healing journey."}
              />
            </div>
            <div className="  border-yellow-500 md:w-[280px] md:h-[300px] h-[200px] w-[340px] content-center sm:my-0  mx-auto md:mx-0  border-t-4  shadow-md rounded-lg text-center ">
              <Box
              images={imagethree}
                title={"Peer Support Programs"}
                content={" Connect with others who understand your experience."}
              />
            </div>
            <div className=" border-purple-500 md:w-[280px] md:h-[300px] h-[200px] w-[340px] content-center sm:my-0  mx-auto md:mx-0  border-t-4  shadow-md rounded-lg text-center">
              <Box
              images={imagefour}
                title={" Individualized Care Plans"}
                content={" Your needs, your pace, your path to recovery"}
              />
            </div>
          </div>
        </div>
        <div className="bg-slate-100 mx-auto p-5 ">
          <div className=" md:flex sm:flex justify-between  gap-3 items-center">
            <div className="w-[100%] sm:w-[50%]">
              <span className="font-roboto text-xl font-bold ">
                BOOK AN APPOINTMENT
              </span>
           
              <p className="font-roboto text-lg mt-5 sm:mt-10  ">
                At Psynexa, we believe that clear, compassionate communication
                is an essential part of exceptional healthcare. Whether you're
                reaching out for information, support, or to schedule a visit,
                our dedicated team is here to ensure you receive the attention
                and care you deserve.
                <p className="font-roboto text-base  mt-4">
                  We welcome patients, family members, healthcare providers, and
                  partners to connect with us through any of the channels below.
                  From general questions to specialist appointments, our goal is
                  to make every interaction as smooth, respectful, and
                  responsive as possible.
                </p>
              </p>
              <p className="font-roboto text-base  mt-4">
                We’re here to help you with all your healthcare needs. Whether
                you have a question, need to book an appointment, or require
                support, our team is ready to assist you.
              </p>
            </div>
            <ApointmentForm />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
